import { IStyle, mergeStyleSets } from "@fluentui/react";

export const PartnerDetailsStyles = mergeStyleSets({
  StackStyleType1:{
    width: "140px"
  } as IStyle,
  StackStyleType2:{
    width: "95px"
  } as IStyle,
  ShimmerStylesType1: {
    marginTop: 10,
    width: 120,
    paddingLeft: 5
  } as IStyle,
  ShimmerStylesType2: {
    marginTop: 10,
    flex: 1,
    paddingLeft: 4,
    paddingRight: 3
  } as IStyle,
  ShimmerStylesType3: {
    marginTop: 10,
    width: 95,
    paddingLeft: 5
  } as IStyle,
  ShimmerStylesType4: {
    marginTop: 10,
    width: 95,
    paddingLeft: 4,
    paddingRight: 3
  } as IStyle,
  IconStyle: {
    marginBottom: "-7px"
  } as IStyle,
  wordWrapStyle: {
    wordWrap: "break-word",
    whiteSpace: "normal"
  } as IStyle
});
